import PageTitleComponent from "../../components/PageTitle";
import CreateNewUser from "../../components/Users/Create";

export default function CreateNewUserScreen(){
return <div>
    <PageTitleComponent title="Create New User" />
    <CreateNewUser/>
</div>
}